import { signal } from "@preact/signals-react"
import { useEffect } from "react"
import { fetchBusinessEntities } from "../utils/api"

export const loadingSignal = signal(false)
export const errorSignal = signal(null)
export const businessEntitiesSignal = signal([])

const fetchData = async (userBusinessEntity, config, accessToken) => {

    // short-circuit if we have a pending request, are waiting for parameters or have already received an error
    if (!userBusinessEntity || loadingSignal.value || !config || !accessToken || errorSignal.value) {
        return
    }

    try {
        loadingSignal.value = true
        let data = await fetchBusinessEntities(userBusinessEntity, true, true, config, accessToken)
        if (data.length) {
            data = data.map((be) => {
                if (be.businessEntityTypeId === 1) {
                    be.isMerchant = true
                    be.beType = 3
                } else if (be.businessEntityTypeId === 2) {
                    be.isOrganization = true
                    be.beType = 2
                    if (be.businessEntitySubTypeId === 1) {
                        be.isStandardOrganization = true
                    } else if (be.businessEntitySubTypeId === 2) {
                        be.isRootOrganization = true
                    } else if (be.businessEntitySubTypeId === 3) {
                        be.isResellerOrganization = true
                        be.beType = 1
                    }
                }
                return be
            })
        }
        // filter out merchants to match legacy ember behavior
        businessEntitiesSignal.value = data.filter(be => be.isOrganization == true)
    }
    catch (err) {
        errorSignal.value = err
    }
    finally {
        loadingSignal.value = false
    }

}

export default function useBusinessEntityData(userBusinessEntity, config, accessToken) {
    useEffect(() => {
        fetchData(userBusinessEntity, config, accessToken)
    }, [userBusinessEntity, config, accessToken])

    return {
        businessEntitiesSignal, loadingSignal, errorSignal
    }
}